import { useState } from "react";
import config from "config";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import { useOktaAuth } from "@okta/okta-react";

import oktaLogout from "features/auth/Logout/utils";
import IconButton from "features/components/IconButton";
import Menu from "features/components/Menu";
import PersonIcon from "features/ui/Icons/PersonIcon";

import { routes } from "services/routes";

const UserMenu = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const { oktaAuth } = useOktaAuth();

  const { isIframed } = config.get();

  if (isIframed) return null;

  return (
    <>
      <IconButton
        size="small"
        color="transparent"
        className="group !border-1 !border-gray-500"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        data-testid="user-menu-button"
      >
        <PersonIcon className="text-gray-200 group-hover:text-gray-100" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(routes.userPreferences);
          }}
          data-testid="user-preferences-menu-item"
        >
          <ListItemIcon>
            <ManageAccountsOutlinedIcon />
          </ListItemIcon>
          {t("common:menu.preferences")}
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => oktaLogout(oktaAuth)}
          data-testid="logout-menu-item"
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          {t("common:menu.logout")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
